<template>
  <div class="search-bar">
    <div class="search-input w-100">
      <b-nav-form @submit.prevent>
        <b-input-group
          :class="{
            inputFocused: searchInputIsFocused,
            inputNoResults: institutions.length === 0 && searchInput !== '',
          }"
        >
          <b-input-group-prepend is-text>
            <icon-base
              height="18"
              title="Suche"
              width="18"
              :color="inputSearchIconColor"
            >
              <icon-search />
            </icon-base>
          </b-input-group-prepend>
          <b-form-input
            id="search-form"
            ref="searchbar"
            list="auto-complete"
            type="text"
            placeholder="Ort, Museum, ..."
            autocomplete="off"
            v-model="searchInput"
            :debounce="275"
            @focus="searchInputIsFocused = true"
            @blur="searchInputIsFocused = false"
          />
          <icon-base
            title="Zurücksetzen"
            id="search-reset-icon"
            v-if="searchInput"
            @click.native="searchInput = ''"
          >
            <icon-reset-input />
          </icon-base>
        </b-input-group>
      </b-nav-form>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

const debounceTrackSiteSearch = debounce(fn => fn(), 1000)

export default {
  name: 'SearchBar',
  data() {
    return {
      searchInputIsFocused: false
    }
  },
  props: {
    institutions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    searchInput: {
      get() {
        return this.$store.state.filters.searchQuery
      },
      set(value) {
        this.$store.dispatch('filters/updateSearchQuery', value)
        debounceTrackSiteSearch(() => this.$matomo.trackSiteSearch(value))
      }
    },
    inputSearchIconColor() {
      return this.searchQuery === '' ? '#869094' : this.institutions.length === 0 ? '#c01252' : '#2978cd'
    }
  },
  methods: {
    focusInput() {
      setTimeout(() => this.$refs.searchbar.focus(), 50)
    },
    blurInput() {
      this.$refs.searchbar.blur()
    }
  }
}
</script>

<style scoped>
.search-bar {
  width: 100%;
  height: 56px;
  padding-top: 4px;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
}

.form-inline {
  display: block;
}

.inputFocused {
  border-color: #000 !important;
}

.inputNoResults {
  border-color: #c01252 !important;
}

.input-group {
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.input-group-prepend {
  border-color: #ced4da;
}

.input-group-text {
  background-color: #fff;
  padding-right: 0;
  border: 0;
}
#search-form {
  padding-right: 42px;
  border: 0;
  box-shadow: none !important;
}
#search-reset-icon {
  position: absolute;
  right: 18px;
  top: 11px;
  z-index: 100;
  cursor: pointer;
}
.btn:focus, .btn:hover {
  background-color: #fff !important;
  box-shadow: none;
  border: 1px solid #fff;
}
.btn:active {
  background-color: rgb(247, 247, 247) !important;
}
</style>
